import React from "react";


import NavBar from "./components/NavBar/NavBar";
import './App.css'
import Main from "./Main";


const App = () => {
  return (
    <div className="App">
      <NavBar />
      <Main />

    </div>
  );
}

export default App;
